export default {
  tasks: [],
  localTasks: [],
  localIdNum: 0,
  totalTaskCount: 0,
  totalProgressTaskCount: 0,
  uploadProgressTaskCount: 0,
  downloadProgressTaskCount: 0,
  taskPageSize: 25,
  taskOffset: 0,
  currentTaskPage: 1,
  selectedFilterStatus: null,
  selectedFilterCategory: null,
  filterName: null,
  menuSidebarActive: true,
  detailSidebarActive: false,
  selectedTask: null,
};